import { logInfo } from "@lib/logger";
import { api } from "./api";

export const iconApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getIcon: build.query<{ svg: string }, { svgName: string }>({
      // Use queryFn instead of query because we must not inherit base url from `.api`.
      queryFn: async ({ svgName }) => {
        try {
          const response = await fetch(`/images/icons/${svgName}.svg`);

          if (!response.ok) {
            return {
              error: {
                status: response.status,
                data: await response.text(),
              },
            };
          }

          const svg = await response.text();

          return { data: { svg } };
        } catch (error) {
          logInfo("Error loading SVG:", error);
          return {
            error: {
              status: "FETCH_ERROR",
              error: String(error),
            },
          };
        }
      },
      providesTags: (_result, _error, { svgName }) => [
        { type: "Icon", id: svgName },
      ],
    }),
  }),
});

export const { useGetIconQuery } = iconApi;

export const {
  endpoints: { getIcon },
} = iconApi;
